// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.95 7.95L10.536 9.364L7.99999 6.828V20H5.99999V6.828L3.46499 9.364L2.04999 7.95L6.99999 3L11.95 7.95ZM21.95 16.05L17 21L12.05 16.05L13.464 14.636L16.001 17.172L16 4H18V17.172L20.536 14.636L21.95 16.05V16.05Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
